import Addresses from '@src/main/modules/messages/ui/addresses/Addresses';

const MessagesAddressesPage = () => <Addresses />;

export default MessagesAddressesPage;
